import Message from './Message';
import Category from './Category';

export default class GenericMediaItem {
    isUSBPowerControl = false;
    hasInfoMessage = false;
    message = new Message();
    title = '';
    inputDevice?: number;
    channelId = '';
    icon?: Category;
    USBPath = '';
}
